// FUNNEL VUEX GETTERS
import {MENUS_PRODUCT_TYPE, TAX_ADJUSTER_TYPE, DISCOUNT_ADJUSTER_TYPE} from '@/js/funnel/_config/commerce';
import {
   isSelectionPage,
   isDeliveryPage,
   isOverviewPage,
} from '@funnel/_config/funnel';

export default {
   /** @return {boolean} */
   isSelectionPage: () => isSelectionPage(),
   /** @return {boolean} */
   isDeliveryPage: () => isDeliveryPage(),
   /** @return {boolean} */
   isOverviewPage: () => isOverviewPage(),

   /**
    * Get the total number of menu sections (courses, drinks, accessories, etc).
    *
    * @param state {object}
    * @return {number}
    */
   totalMenuSections(state) {
      return state.menu.sections.length;
   },

   /**
    * Get the GROSS (after tax) grand total of everything in the cart.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {number}
    */
   summarySubtotalGross(state, getters) {
      // if the summary hasn't loaded yet, just return 0
      if (!Object.keys(state.summary).length) {
         return 0;
      }

      // add up the total below for the Selection page
      let total = 0;
      for (let productType in state.summary.lineItems) {
         // if this is the package menu, add its data
         if (productType === MENUS_PRODUCT_TYPE) {
            if(state.menu.isALaCarte) {
               continue;
            }

            if(!state.summary.lineItems[MENUS_PRODUCT_TYPE]) {
               continue;
            }

            if (Object.keys(state.summary.lineItems[MENUS_PRODUCT_TYPE]).length) {
               total += (state.summary.lineItems[MENUS_PRODUCT_TYPE].price.gross * state.summary.lineItems[MENUS_PRODUCT_TYPE].quantity);
            }

            continue;
         }

         let lineItems = state.summary.lineItems[productType];
         if (Object.keys(lineItems).length < 1) {
            continue;
         }

         for (let slug in lineItems) {
            total += (lineItems[slug].price.gross * lineItems[slug].quantity);
         }
      }

      // add up the adjustments' totals
      for (let type in state.summary.adjustments) {
         if(type == TAX_ADJUSTER_TYPE) {
            continue;
         }
         for (let adjuster of state.summary.adjustments[type]) {
            total += adjuster.price.gross * adjuster.quantity;
         }
      }

      return total;
   },

   /**
    * Get the GROSS (after tax and discount) grand total of everything in the cart.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {number}
    */
   summarySubtotalGrossBeforeDiscount(state, getters) {
      // if the summary hasn't loaded yet, just return 0
      if (!Object.keys(state.summary).length) {
         return 0;
      }

      // add up the total below for the Selection page
      let total = 0;
      for (let productType in state.summary.lineItems) {
         // if this is the package menu, add its data
         if (productType === MENUS_PRODUCT_TYPE) {
            if(state.menu.isALaCarte) {
               continue;
            }

            if(!state.summary.lineItems[MENUS_PRODUCT_TYPE]) {
               continue;
            }

            if (Object.keys(state.summary.lineItems[MENUS_PRODUCT_TYPE]).length) {
               total += (state.summary.lineItems[MENUS_PRODUCT_TYPE].price.gross * state.summary.lineItems[MENUS_PRODUCT_TYPE].quantity);
            }

            continue;
         }

         let lineItems = state.summary.lineItems[productType];
         if (Object.keys(lineItems).length < 1) {
            continue;
         }

         for (let slug in lineItems) {
            total += (lineItems[slug].price.gross * lineItems[slug].quantity);
         }
      }

      // add up the adjustments' totals
      for (let type in state.summary.adjustments) {
         if(type == TAX_ADJUSTER_TYPE || type == DISCOUNT_ADJUSTER_TYPE) {
            continue;
         }
         for (let adjuster of state.summary.adjustments[type]) {
            total += adjuster.price.gross * adjuster.quantity;
         }
      }

      return total;
   },

   /**
    * Get the GROSS (after tax) grand total of everything in the cart.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {number}
    */
   summaryTotalGross(state, getters) {
      // if the summary hasn't loaded yet, just return 0
      if (!Object.keys(state.summary).length) {
         return 0;
      }

      // total of line items (including tax)
      let total = getters.summarySubtotalGross;

      // add up the adjustments' totals
      for (let type in state.summary.adjustments) {
         if(type != TAX_ADJUSTER_TYPE) {
            continue;
         }
         for (let adjuster of state.summary.adjustments[type]) {
            total += adjuster.price.gross * adjuster.quantity;
         }
      }

      return total;
   },

   /**
    * Get the total of everything in the cart (line items & adjustments) BEFORE tax is added.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {number}
    */
   summarySubtotalNet(state, getters) {
      // if the summary hasn't loaded yet, just return 0
      if (!Object.keys(state.summary).length) {
         return 0;
      }

      // add up the line items' totals
      let total = 0;
      for (let productType in state.summary.lineItems) {
         // if this is the package menu, add its data
         if (productType === MENUS_PRODUCT_TYPE) {
            if (!state.menu.isALaCarte && Object.keys(state.summary.lineItems[MENUS_PRODUCT_TYPE]).length) {
               total += (state.summary.lineItems[MENUS_PRODUCT_TYPE].price.net * state.summary.lineItems[MENUS_PRODUCT_TYPE].quantity);
            }
            continue;
         }

         let lineItems = state.summary.lineItems[productType];
         if (Object.keys(lineItems).length < 1) {
            continue;
         }

         for (let slug in lineItems) {
            total += (lineItems[slug].price.net * lineItems[slug].quantity);
         }
      }

      return total;
   },

   /**
    * Get the total of everything in the cart (line items & adjustments) BEFORE tax is added.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {number}
    */
   summaryTotalNet(state, getters) {
      // if the summary hasn't loaded yet, just return 0
      if (!Object.keys(state.summary).length) {
         return 0;
      }

      // add up the line items' totals
      let total = getters.summarySubtotalNet;

      // add up the adjustments' totals
      for (let type in state.summary.adjustments) {
         for (let adjuster of state.summary.adjustments[type]) {
            total += adjuster.price.net * adjuster.quantity;
         }
      }

      return total;
   },

   /**
    * Detect if the subtotal in the summary meets the minimum amount the customer must spend on
    * this menu.
    *
    * @returns {boolean}
    */
   isMinimumOrderValueMet(state, getters) {
      if (state.menu.isALaCarte) {
         return getters.summarySubtotalGrossBeforeDiscount >= (state.menu.minimumOrderValue * 100);
      }

      let isFulfilled = true
      state.menu.sections.forEach((sec, index) => {
         isFulfilled = isFulfilled && sec.isFulfilled
      })
      return isFulfilled;
   },

   /**
    * Are positive Availability Check results required for the customer to continue in the funnel?
    *
    * @param state {object}
    * @return {boolean}
    */
   isCatererAvailabilityRequired(state) {
      try {
         return window.mymy.cart.availability.isRequired;
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
         return false;
      }
   },

   /**
    * Get the latest availability check results that the customer triggered.
    *
    * @param state {object}
    * @return {object|null}
    */
   firstAvailabilityCheck(state) {
      try {
         return state.availability.checks[0];
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
         return null;
      }
   },

   /**
    * Get the latest availability check results that had availability.
    *
    * @param state {object}
    * @return {object|null}
    */
   firstSuccessfulAvailabilityCheck(state) {
      try {
         for (let result of state.availability.checks) {
            if (result.isAvailable) {
               return result;
            }
         }
      }
      catch (e) {
         if(window.Sentry) {
            Sentry.captureException(e);
         }
         console.error(e);
      }

      return null;
   },

   /**
    * Check whether the customer has selected a menu that our caterers are available to serve on
    * the customer's selected delivery date and address provided.
    *
    * @param state {object}
    * @param getters {object}
    * @return {boolean}
    */
   cartHasCatererAvailability(state, getters) {
      return typeof getters.firstSuccessfulAvailabilityCheck === 'object';
   },

   /**
    * The default minimum amount of people required for ANY menu to be selected by a customer.
    *
    * @param state {object}
    * @return {integer}
    */
   defaultMinMenuQuantity(state) {
      return window.mymy.menu.quantity.default.min;
   },

   /**
    * Get the menu data object that will be included in the Availability Check process when the
    * form submits.
    *
    * @param state {object}
    * @param getters {object}
    * @return {object|null}
    */
   targetMenu(state, getters) {
      return state.menu;
   },

   /**
    * The minimum amount of people required for the menu to be selected by the customer.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {integer}
    */
   minMenuQuantity(state) {
      return window.mymy.menu.quantity.min;
   },

   /**
    * The default maximum amount of people required for ANY menu to be selected by a customer.
    *
    * @param state {object}
    * @return {integer}
    */
   defaultMaxMenuQuantity(state) {
      return window.mymy.menu.quantity.default.max;
   },

   /**
    * The maximum amount of people allowed for the menu to be selected by the customer.
    *
    * @param state {object}
    * @param getters {object}
    * @returns {integer}
    */
   maxMenuQuantity(state) {
      return window.mymy.menu.quantity.max;
   },
}